import React from 'react'
import PropTypes from 'prop-types'
import withLayout from '../../../layout/withLayout'
import { lifecycle } from 'recompose'
import UserAdmin from './UserAdmin'
import UserSelection from './UserSelection'

const ManageUser = (props) => {
    return (
        <div>
            <UserSelection {...props}/>
            <UserAdmin {...props}/>
        </div>
    )
}

ManageUser.propTypes = {
    isUniqueConstraintViolation: PropTypes.bool.isRequired,
    createUser: PropTypes.func.isRequired,
    userList: PropTypes.array.isRequired,
    partnerList: PropTypes.array.isRequired,
    storeList: PropTypes.array.isRequired,
    findAllUser: PropTypes.func.isRequired,
    generateNewPassword: PropTypes.func.isRequired,
    changeCurrentUserId: PropTypes.func.isRequired,
    createEmployee: PropTypes.func.isRequired,
    changeExternalUser: PropTypes.func.isRequired,
    createExternalUser: PropTypes.func.isRequired,
    toggleRole: PropTypes.func.isRequired,
    toggleWidgetAccess: PropTypes.func.isRequired,
    salutationList: PropTypes.array.isRequired,
    changeUser: PropTypes.func.isRequired,
    currentUser: PropTypes.object,
    passwordStatus: PropTypes.string,
    saveUser: PropTypes.func.isRequired,
    validationMessageList: PropTypes.array.isRequired,
    findAllRole: PropTypes.func.isRequired,
}

export default lifecycle({
    componentDidMount () {
        this.props.findAllUser()
        this.props.findAllRole()
    },
})(withLayout(ManageUser))




// WEBPACK FOOTER //
// ./src/modules/security/component/manage/ManageUser.js